import { useCallback } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { isInternalContent } from 'academy-common-lib/features/learningContent/utils';
import { useLearningContentCardTo } from '../cardsHooks';
import { CardMenuIcon } from '../../cardMenu';
import { ACContentCardSmall } from 'academy-common-lib/components/card/ACContentCardSmall';
import { ThumbnailTypeMap } from 'academy-common-lib/features/cards/constants';
import LearningContentCardAwardLink from './LearningContentCardAwardLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReducedLearningContentCard = ({
  item,
  overviewType,
  position,
  playlistId,
  onItemClick,
  use = 'on-light',
  size = 'small',
  showOverview,
  body,
  cardBody,
  footer,
  thumbnailOverlay,
  renderMenu = menu => menu,
  disableLink,
  completionPercentage,
  'data-test-id': dataTestId = 'learning-content-card',
  isGhost,
  ribbonText,
  ribbonUse,
  isNotFilterable,
  menuAlwaysVisible,
  selected
}) => {
  const {
    id,
    type,
    language,
    name,
    progress,
    previewThumbnailSquareUrl
  } = item;
  const completed = (progress === null || progress === void 0 ? void 0 : progress.status) === 'COMPLETED';
  const {
    itemsCount = 0
  } = item;
  const {
    completedItemsCount = 0
  } = progress || {};
  const award = progress === null || progress === void 0 ? void 0 : progress.award;
  const to = useLearningContentCardTo({
    item,
    overviewType,
    playlistId,
    showOverview
  });
  const {
    certification,
    duration
  } = item;
  const handleClick = useCallback(() => {
    if (onItemClick) onItemClick(item);
    if (!disableLink) UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: type,
      contentId: id,
      appearsIn: overviewType,
      position,
      name,
      style: 'reduced',
      isInProgress: (progress === null || progress === void 0 ? void 0 : progress.status) === 'IN_PROGRESS',
      isCertification: certification,
      playlistId
    });
  }, [onItemClick, item, disableLink, type, id, overviewType, position, name, progress === null || progress === void 0 ? void 0 : progress.status, certification, playlistId]);
  const getProgress = () => {
    if (completed || completionPercentage === 100) return duration || itemsCount;
    if (type === 'PLAYLIST') {
      return completedItemsCount;
    }
    return (duration || itemsCount) * (completionPercentage || (progress === null || progress === void 0 ? void 0 : progress.completedPercentage) || 0) / 100;
  };
  return /*#__PURE__*/_jsx(ACContentCardSmall, {
    awardLink: /*#__PURE__*/_jsx(LearningContentCardAwardLink, {
      award: award,
      use: "on-light"
    }),
    cardBody: cardBody,
    cardMenu: renderMenu( /*#__PURE__*/_jsx(CardMenuIcon, {
      item: {
        id,
        language: language,
        type: type
      },
      overviewType: overviewType,
      use: use === 'on-dark' ? 'tertiary' : use === 'on-surface-recessed' ? 'tertiary-light' : 'tertiary-extra-light'
    })),
    contentHref: to.fullUrl,
    contentType: certification ? 'CERTIFICATION' : ThumbnailTypeMap[type],
    "data-test-id": dataTestId,
    "data-test-is-certification": Boolean(certification),
    "data-test-is-ghost": Boolean(isGhost),
    "data-test-is-unfilterable": Boolean(isNotFilterable),
    description: body,
    footer: footer,
    imageSrc: previewThumbnailSquareUrl,
    isGhost: isGhost,
    isInternalContent: isInternalContent(item),
    length: duration || itemsCount,
    lengthType: type === 'PLAYLIST' || type === 'LEARNING_PATH' ? 'items' : 'time',
    linkMode: "react-router",
    menuAlwaysVisible: menuAlwaysVisible,
    name: name,
    onClick: handleClick,
    overviewType: overviewType,
    progress: getProgress(),
    ribbonText: ribbonText,
    ribbonUse: ribbonUse,
    selected: selected,
    size: size === 'medium' ? 100 : 60,
    thumbnailOverlay: thumbnailOverlay
  });
};
export default ReducedLearningContentCard;